export const humanFileSize = (size) => {
    if (Number.isNaN(Number(size))) {
        return 'This is not a valid file size';
    }
    const BASE = 1024;
    const i = Math.floor(Math.log(size) / Math.log(BASE));

    return `${(size / BASE ** i).toFixed(2) * 1} ${['o', 'ko', 'Mo', 'Go', 'To'][i]}`;
};
